import styled from 'styled-components';

import { Flex } from '@/components/base';
import Typo from '@/components/Typography/Typo';

type Props = {
  count: number;
};

const CountBadge = (props: Props) => {
  return (
    <Style a="center" j="center">
      <Typo type="label1" weight="sb">
        {props.count}
      </Typo>
    </Style>
  );
};

const Style = styled(Flex)`
  padding: 6px 8px;
  min-width: 32px;
  border-radius: 32px;
  background-color: ${(props) => props.theme.colors.gray250};
`;

export default CountBadge;
